import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatIsoDate = (isoDate) => {
  const date = new Date(isoDate);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};

export function convertToVNTime(input) {
  // Xử lý các trường hợp null, undefined, hoặc giá trị không hợp lệ
  if (input === null || input === undefined || input === '') {
    return '-';
  }

  let dateObj;

  if (typeof input === "number") {
    // Kiểm tra nếu là số hợp lệ
    if (isNaN(input) || !isFinite(input)) {
      return '-';
    }
    const isSecondsEpoch = input < 1e12;
    dateObj = isSecondsEpoch ? dayjs.unix(input).utc() : dayjs.utc(input);
  } 
  else if (typeof input === "string") {
    let fixedStr = input.trim();

    if (fixedStr === '') {
      return '-';
    }

    if (/^\d+$/.test(fixedStr)) {
      const num = Number(fixedStr);
      if (isNaN(num) || !isFinite(num)) {
        return '-';
      }
      const isSecondsEpoch = num < 1e12;
      dateObj = isSecondsEpoch ? dayjs.unix(num).utc() : dayjs.utc(num);
    } else {
      fixedStr = fixedStr.replace(/\.(\d{3})\d*(?=(Z|[+-]\d{2}:\d{2})$)/, ".$1");

      if (!/(Z|[+-]\d{2}:\d{2})$/.test(fixedStr)) {
        fixedStr = fixedStr.replace(/\.(\d{3})\d*$/, ".$1");
        fixedStr = `${fixedStr}Z`;
      }

      dateObj = dayjs.utc(fixedStr);
    }
  } 
  else {
    // Thay vì throw error, trả về '-' cho các kiểu dữ liệu không hỗ trợ
    return '-';
  }

  // Kiểm tra xem dateObj có hợp lệ không
  if (!dateObj || !dateObj.isValid()) {
    return '-';
  }

  // Trả về giờ Việt Nam
  return dateObj.tz("Asia/Ho_Chi_Minh").format("YYYY-MM-DD HH:mm:ss");
}
